import { em } from 'polished'
import styled from 'styled-components'

export const Image = styled.img`
  position: relative;
  width: 100%;

  ${p => p.theme.mq.upLg} {
    bottom: auto;
    top: ${em(-100)};
  }
`
